import { render, staticRenderFns } from "./distributionClass.vue?vue&type=template&id=6d207570&scoped=true&"
import script from "./distributionClass.vue?vue&type=script&lang=js&"
export * from "./distributionClass.vue?vue&type=script&lang=js&"
import style0 from "./distributionClass.vue?vue&type=style&index=0&id=6d207570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d207570",
  null
  
)

export default component.exports